// Fix for deferred-media video playback in product slider
document.addEventListener('DOMContentLoaded', function() {
  // Listen for clicks on deferred media buttons
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.deferred-media__poster');
    if (button) {
      const deferredMedia = button.closest('deferred-media');
      if (deferredMedia && !deferredMedia.getAttribute('loaded')) {
        e.preventDefault();
        deferredMedia.loadContent();
      }
    }
  });
});
